/*
 *
 * ProjectDetailsPage reducer
 *
 */
import produce from 'immer';
import {
  UPDATE_NETWORK_STATUS,
  GET_PUSHER_CHANNELS,
  GET_AGENT_DETAILS,
  GET_SLACK_CHANNELS,
  GET_USER_STATUS,
  UPDATE_USER_STATUS,
  LOGOUT_USER,
  UPDATE_PROFILE_IMG,
  UPDATE_PROFILE_DATA,
  GET_TIMEZONE_LIST,
  GET_RECENT_GIFS,
  GET_TRENDING_GIFS,
  GET_SEARCHED_GIFS,
} from './constants';

export const initialState = {
  networkStatus: 'online',
  pusherMessage: {},
  pusherChannels: [],
  isProfileCompleted: true,
  isProfileLoading: true,
  profileDetails: {},
  slackChannels: {
    loading: false,
    data: {},
  },
  userStatus: false,
  logoutUser: {
    loading: false,
    error: false,
  },
  timezoneList: {
    loading: false,
    data: [],
    error: '',
    initialApiCall: true,
  },
  gifs: {
    recent: {
      loading: false,
      data: [],
    },
    trending: {
      loading: false,
      data: [],
      pagination: {},
    },
    searched: {
      loading: false,
      data: [],
      pagination: {},
    },
  },
};

/* eslint-disable default-case, no-param-reassign */
const projectDetailsPageReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case UPDATE_NETWORK_STATUS:
        draft.networkStatus = action.payload.data;
        break;

      case GET_PUSHER_CHANNELS.SUCCESS:
        draft.pusherChannels = action.payload.data.pusherChannels;
        break;

      case GET_AGENT_DETAILS.START:
        draft.isProfileLoading = true;
        break;
      case GET_AGENT_DETAILS.SUCCESS:
        draft.isProfileCompleted = action.payload.data;
        draft.isProfileLoading = false;
        draft.profileDetails = { ...draft.profileDetails, ...action.payload.details };
        break;

      case UPDATE_PROFILE_IMG:
        draft.profileDetails = { ...draft.profileDetails, img: action.payload.data.imageUrl };
        break;

      case GET_SLACK_CHANNELS.START:
        draft.slackChannels.loading = true;
        draft.slackChannels.error = false;
        break;

      case GET_SLACK_CHANNELS.SUCCESS:
        draft.slackChannels.loading = false;
        draft.slackChannels.error = false;

        if (action.payload.data) {
          draft.slackChannels.data = action.payload.data;
        }
        break;

      case GET_SLACK_CHANNELS.ERROR:
        draft.slackChannels.loading = false;
        draft.slackChannels.error = action.payload.error;

        if (action.payload.data) {
          draft.slackChannels.data = action.payload.data;
        }
        break;

      case GET_USER_STATUS.SUCCESS:
        draft.userStatus = action.payload.data.available;
        break;

      case UPDATE_USER_STATUS.SUCCESS:
        draft.userStatus = action.payload.data.available;
        break;

      case LOGOUT_USER.START:
        draft.logoutUser.loading = true;
        break;

      case LOGOUT_USER.SUCCESS:
        draft.logoutUser.loading = false;
        break;

      case LOGOUT_USER.ERROR:
        draft.logoutUser.loading = false;
        draft.logoutUser.error = action.payload.error;
        break;

      case UPDATE_PROFILE_DATA:
        draft.profileDetails = { ...action.payload.data };
        break;

      case GET_TIMEZONE_LIST.START:
        draft.timezoneList.loading = true;
        break;

      case GET_TIMEZONE_LIST.SUCCESS:
        draft.timezoneList.loading = false;
        draft.timezoneList.initialApiCall = false;
        draft.timezoneList.data = action.payload.data;
        break;

      case GET_TIMEZONE_LIST.ERROR:
        draft.timezoneList.loading = false;
        draft.timezoneList.initialApiCall = false;
        draft.timezoneList.error = action.payload.error;
        break;

      case GET_RECENT_GIFS.START:
        draft.gifs.recent.loading = true;
        draft.gifs.recent.data = [];
        break;

      case GET_RECENT_GIFS.SUCCESS:
        draft.gifs.recent.loading = false;
        draft.gifs.recent.data = action.payload.data;
        break;

      case GET_RECENT_GIFS.ERROR:
        draft.gifs.recent.loading = false;
        break;

      case GET_TRENDING_GIFS.START:
        draft.gifs.trending.loading = true;
        break;

      case GET_TRENDING_GIFS.SUCCESS:
        draft.gifs.trending.loading = false;
        draft.gifs.trending.data = [...state.gifs.trending.data, ...action.payload.data.data];
        draft.gifs.trending.pagination = action.payload.data.pagination;
        break;

      case GET_TRENDING_GIFS.ERROR:
        draft.gifs.trending.loading = false;
        break;

      case GET_SEARCHED_GIFS.START:
        draft.gifs.searched.loading = true;
        break;

      case GET_SEARCHED_GIFS.SUCCESS:
        draft.gifs.searched.loading = false;
        if (action.metadata.resetQuery) {
          draft.gifs.searched.data = action.payload.data.data;
        } else {
          draft.gifs.searched.data = [...state.gifs.searched.data, ...action.payload.data.data];
        }
        draft.gifs.searched.pagination = action.payload.data.pagination;
        break;

      case GET_SEARCHED_GIFS.ERROR:
        draft.gifs.searched.loading = false;
        break;

      default:
        break;
    }
  });
};

export default projectDetailsPageReducer;
